import request from '@/utils/request'

export function login(username, password) {
    return request({
        url: '/api/PmiUser/Login?deptId=1',
        method: 'get',
        params: { loginName: username, password: password }
    })
}